<template>
  <div class="xl:px-32 lg:px-20 md:px-14 px-10 bg-white">
    <div class="bg-white pt-5 text-center">
      <h2 class="md:text-3xl sm:text-2xl text-xl font-bold text-[#006]">
        Medidas de Prevención
      </h2>
      <h3
        class="text-black md:text-lg sm:text-base text-sm pt-5 text-center pb-5"
      >
        Si deseas participar de PROCESA 2022, debes tomar en cuenta las
        siguientes recomendaciones.
      </h3>
    </div>

    <div class="pb-[10px] md:text-justify">
      <div class="collapse collapse-plus rounded-xl border border-[#00bffe]">
        <input type="checkbox" class="peer" />
        <div
          class="collapse-title font-bold text-black md:text-lg sm:text-base text-sm peer-checked: peer-checked:text-black peer-checked:font-bold px-4"
        >
          Ingreso al Perú
        </div>
        <div
          class="collapse-content text-white peer-checked: peer-checked:text-black peer-checked:text-justify"
        >
          <div class="flex items-center px-5 pb-2">
            <img
              class="pr-5"
              src="../../assets/protocolos/bx-check.svg"
              alt=""
            />

            <p class="md:text-lg sm:text-base text-sm">
              Los ciudadanos de Colombia, Bolivia, Ecuador, Argentina, Brasil,
              Chile, Paraguay y Uruguay que viajan al Perú con fines de turismo,
              pueden ingresar al territorio nacional portando únicamente su
              documento o cédula nacional de identidad.
            </p>
          </div>
          <div class="flex items-center px-5 pb-2">
            <img
              class="pr-5"
              src="../../assets/protocolos/bx-check.svg"
              alt=""
            />

            <p class="md:text-lg sm:text-base text-sm">
              Los ciudadanos de Venezuela precisan de contar con algún tipo de
              visado para poder ingresar al Perú, salvo que cuenten con
              residencia permanente en algún país miembro de la Alianza del
              Pacífico (Chile, Colombia o México).
            </p>
          </div>
          <div class="flex items-center px-5 pb-2">
            <img
              class="pr-5"
              src="../../assets/protocolos/bx-check.svg"
              alt=""
            />

            <p class="md:text-lg sm:text-base text-sm">
              Para conocer la información precisa para cada país les
              recomendamos revisar las páginas de los consulados de Perú en sus
              países.
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="pb-[10px] md:text-justify">
      <div class="collapse collapse-plus rounded-xl border border-[#00bffe]">
        <input type="checkbox" class="peer" />
        <div
          class="collapse-title font-bold text-black md:text-lg sm:text-base text-sm peer-checked: peer-checked:text-black peer-checked:font-bold px-4"
        >
          Requisitos sanitarios al Perú
        </div>
        <div
          class="collapse-content text-white peer-checked: peer-checked:text-black peer-checked:text-justify"
        >
          <div class="flex items-center px-5 pb-2">
            <img
              class="pr-5"
              src="../../assets/protocolos/bx-check.svg"
              alt=""
            />

            <p class="md:text-lg sm:text-base text-sm">
              Para poder viajar al Perú, todas las personas deberán llenar
              previamente la
              <a
                target="_blank"
                href="https://e-notificacion.migraciones.gob.pe/dj-salud/"
                class="link link-accent text-[#00BFFF]"
                >Declaración Jurada de Salud</a
              >
              dentro de las 72 horas anteriores al viaje. Recuerde guardar la
              imagen de dicha declaración de forma virtual o impresa, lo que
              resulta indispensable para el embarque a cargo de la aerolínea.
            </p>
          </div>
          <div class="flex items-center px-5 pb-2">
            <img
              class="pr-5"
              src="../../assets/protocolos/bx-check.svg"
              alt=""
            />

            <p class="md:text-lg sm:text-base text-sm">
              Los extranjeros no residentes cuyo destino final sea el territorio
              nacional en calidad de pasajeros e independientemente del país de
              procedencia deben contar con la vacunación completa de acuerdo al
              esquema de su país de origen. En su defecto, se puede presentar
              una prueba molecular (PCR) negativa con fecha de resultado que no
              sea mayor a 48 horas antes de la hora de embarque en su punto de
              origen.
            </p>
          </div>
          <div class="flex items-center px-5 pb-2">
            <img
              class="pr-5"
              src="../../assets/protocolos/bx-check.svg"
              alt=""
            />

            <p class="md:text-lg sm:text-base text-sm">
              Para conocer la información precisa para cada país les
              recomendamos revisar las páginas de los consulados de Perú en sus
              respectivos países.
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="pb-[10px] md:text-justify">
      <div class="collapse collapse-plus rounded-xl border border-[#00bffe]">
        <input type="checkbox" class="peer" />
        <div
          class="collapse-title font-bold text-black md:text-lg sm:text-base text-sm peer-checked: peer-checked:text-black peer-checked:font-bold px-4"
        >
          Ingreso al campus de UTEC
        </div>
        <div
          class="collapse-content text-white peer-checked: peer-checked:text-black peer-checked:text-justify"
        >
          <div class="flex items-center px-5 pb-2">
            <img
              class="pr-5"
              src="../../assets/protocolos/bx-check.svg"
              alt=""
            />

            <p class="md:text-lg sm:text-base text-sm">
              Para el ingreso al campus se solicitará un documento de identidad
              así como la vacunación completa, también deberá permanecer con
              doble mascarilla o mascarilla KN-95, adicionalmente si eres
              participante internacional es necesario contar con un seguro de
              salud o si participarás del ChemE Car Competition será necesario
              contar también con un seguro contra accidentes (pueden revisarlo
              por ejemplo en
              <a
                target="_blank"
                href="https://www.assistcard.com/"
                class="link link-accent text-[#00BFFF]"
                >https://www.assistcard.com</a
              >
              )
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style></style>
